import { Box, BoxProps, Text } from '@jfs/ui-new'
import { useNavigation, useRoute } from '@react-navigation/native'
import { FC } from 'react'
import { ModBox } from '../../comps/ModifiedBox/ModifiedBox'
import { SvgImage } from '../../comps/SvgImage'
import { TableComponent } from '../../comps/TableComponent'
import { useStores } from '../../data/store'
import { renderItemBanKDetail } from './FlatlistHelpers'
import { Platform } from 'react-native'
import { HeaderLeft } from '../../comps/MobileCustomHeader/HeaderLeft'

const keyExtractor = (item: any): string => {
  return item.bankId
}

const SettlementBankAccount: FC<any> = () => {
  const navigation = useNavigation()

  const { getAccounts } = useStores((store) => ({
    getAccounts: store?.user.getAccounts,
  }))

  const params = useRoute()?.params ?? {}
  const { header }: any = params

  const headerLeft = () => {
    return (
      <Box backgroundColor={'TRANSPARENT'} flexDirection="row" justifyContent="center" alignItems={'center'}>
        <ModBox
          paddingLeft={25}
          paddingRight={10}
          top={ Platform.OS === 'ios' ? -30 : 0}
          show={navigation.canGoBack()}
          underlayColor={'TRANSPARENT'}
          onPress={() => navigation.goBack()}>
          <SvgImage imageName="HeaderArrowLeft" />
        </ModBox>
      </Box>
    )
  }

  navigation.setOptions({
    title: header,
    headerTintColor: '#fff',
    headerBackVisible: true,
    headerShadowVisible: false,
    headerTransparent: true,
    headerLeft:Platform.OS === 'ios' ? headerLeft : () => <HeaderLeft />,
    headerTitleStyle: {
      fontSize: 16,
      fontFamily: 'JioType-Bold',
      top:Platform.OS === 'ios' ? -30 : 0,
    },
  })

  const acDetails = getAccounts()

  const accDetailsArrayFirstObj = acDetails?.[0]
  const ifscOfFirstObj = accDetailsArrayFirstObj?.ifsc
  const isBankAccountAvailable = ifscOfFirstObj !== '' && typeof ifscOfFirstObj !== 'undefined'

  return (
    <Box flex={1} bg="SECONDARY">
      <ModBox show={isBankAccountAvailable} f={1}>
        <Box {...styles.profileListWrapper} flex={1}>
          <TableComponent
            value={''} //Routes value
            canFetchMore={false}
            hide={false}
            isCustom={true}
            ListContent={acDetails ?? []}
            RenderCustomElement={({ item }: any) => renderItemBanKDetail(item)}
            keyExtractor={keyExtractor}
          />
        </Box>
      </ModBox>
      <ModBox show={!isBankAccountAvailable} f={1} align="center" justify="center">
        <Text type="h2Bold" color={'WHITE'} fontFamily={'JioType-Bold'}>
          {'No accounts Added!'}
        </Text>
      </ModBox>
    </Box>
  )
}

const styles = {
  profileListWrapper: {
    backgroundColor: 'WHITE',
    padding: 25,
    borderTopLeftRadius: 30,
    borderTopRightRadius: 30,
    // position: 'absolute',
    // bottom: 0,
    // left: 0,
    width: '100%',
    marginTop: Platform.OS == 'android' ? 90 : 70,
    flex: 1,
    zIndex: 4,
    overflow: 'auto',
  } as BoxProps,
}

export default SettlementBankAccount
